var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoffeeMakerSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_3228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.86 1.5H5.32C4.30687 1.5 3.33524 1.90246 2.61885 2.61885C1.90246 3.33524 1.5 4.30687 1.5 5.32V7.23H14.86V18.68H1.5V22.5H22.5V5.32C22.5 4.30687 22.0975 3.33524 21.3811 2.61885C20.6648 1.90246 19.6931 1.5 18.68 1.5H14.86Z",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41037 12H11.0004V15.38C11.0004 16.2579 10.6516 17.0998 10.0309 17.7205C9.41015 18.3413 8.56824 18.69 7.69037 18.69H6.69037C5.8125 18.69 4.97059 18.3413 4.34985 17.7205C3.7291 17.0998 3.38037 16.2579 3.38037 15.38V12H3.41037Z",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22998 9.14047V7.23047",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.73 18.6797H19.64",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.73 14.8604H19.64",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.73 11.0498H19.64",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_3228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeMakerSvgrepocom);
export default __webpack_public_path__ + "static/media/coffee-maker_svgrepo.com.93fc023390c69ded66582fb12b867c40.svg";
export { ForwardRef as ReactComponent };